import { IgenomicsAction } from '@ispm/core/interfaces/genomics-action.interface';
import { CacheablesEntity } from '@ispm/core/entities/cacheables.entity';
import { GeneralStoreEntity } from '@ispm/core/entities/general-store.entity';

export abstract class AGeneralActionCreator<T= any> implements IgenomicsAction {
  abstract type: string;
  public payload: GeneralStoreEntity<T>;
  public payloadType: typeof CacheablesEntity;

  protected constructor(payload: T);
  protected constructor(payload: T, payloadType: typeof CacheablesEntity | typeof GeneralStoreEntity)
  protected constructor(payload: T, payloadType: typeof CacheablesEntity | typeof GeneralStoreEntity = GeneralStoreEntity) {
    this.payload = payload instanceof payloadType
      ? payload as GeneralStoreEntity<T>
      : payloadType.builder(payload);
  }

}
